import React, { FC, useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../../../store';

import Button from '../../../../../../components/Button';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

export type TSectionSelected = 'Scorecards' | 'Leaderboards';

interface IProps {
  onSectionOnClick: (section: TSectionSelected) => () => void;
  sectionSelected: TSectionSelected;
}

export const RoundResultsSectionSelector: FC<IProps> = props => {
  const { sectionSelected, onSectionOnClick } = props;

  const scorecardsState = sectionSelected === 'Scorecards' ? '' : 'in';
  const leaderboardsState = sectionSelected === 'Leaderboards' ? '' : 'in';

  const { adminRoundFormats } = useContext(GlobalContext);
  const { roundId } = useRouteInfoState();

  const [hidePlayerScorecards, setHidePlayerScorecards] = useState(false);

  useEffect(() => {
    const roundFormats = roundId ? adminRoundFormats[Number(roundId)] : null;

    if (!!roundFormats) {
      const isScramble = roundFormats.some(format => format.format.prefix.includes('scramble'));

      setHidePlayerScorecards(isScramble);
    }
  }, [roundId, adminRoundFormats]);

  return (
    <div className="assign-awards-section-selector">
      {!hidePlayerScorecards && (
        <Button
          classes={{ label: 'list-filter__label' }}
          className={`list-filter list-filter--${scorecardsState}active list-filter--player`}
          color="primary"
          variant={scorecardsState === 'in' ? 'outlined' : 'contained'}
          onClick={onSectionOnClick('Scorecards')}
        >
          PLAYER SCORECARDS
        </Button>
      )}

      <Button
        classes={{ label: 'list-filter__label' }}
        className={`list-filter list-filter--${leaderboardsState}active list-filter--player`}
        color="primary"
        variant={leaderboardsState === 'in' ? 'outlined' : 'contained'}
        onClick={onSectionOnClick('Leaderboards')}
      >
        LEADERBOARDS
      </Button>
    </div>
  );
};
